import { Avatar } from "@material-ui/core";
import React from "react";
import "./story.css";

const Story = ({ image, profileSrc, title }) => {
  const styles = {
    backgroundImage: `url(${image})`,
    position: "relative",
    backgrounPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "120px",
    height: "200px",
    boxShadow: "0px 5px 17px -7px rgba(0, 0, 0, 0.75)",
    borderRadius: "10px",
    marginRight: "10px",
    cursor: "pointer",
    transition: "transform 100ms ease-in",
    "&:hover": {
      transform: "scale(1.07)",
    },
  };
  return (
    <div className="story-wrapper" style={styles}>
      <Avatar src={profileSrc} className="story__avatar" />
      <h4 className="h4">{title}</h4>
    </div>
  );
};

export default Story;
